import { render, staticRenderFns } from "./ImgLazy.vue?vue&type=template&id=143ef0d9&"
import script from "./ImgLazy.vue?vue&type=script&lang=js&"
export * from "./ImgLazy.vue?vue&type=script&lang=js&"
import style0 from "./ImgLazy.vue?vue&type=style&index=0&id=143ef0d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports